<button *ngIf="!iconOnly" type="button" mat-button class="btn actionButton export-button"
  [matMenuTriggerFor]="exportMenu" [disabled]="disabled || requesting || !scope">
  <span class="export-button__content">
    <span class="export-button__icon" [innerHTML]="icons['file-download']"></span>
    {{ 'GENERAL.EXPORT' | translate }}
  </span>
</button>

<button *ngIf="iconOnly" type="button" mat-icon-button class="export-button__iconOnly"
  [matMenuTriggerFor]="exportMenu" [disabled]="disabled || requesting || !scope"
  [attr.aria-label]="'GENERAL.EXPORT' | translate" (click)="$event.stopPropagation()">
  <span class="export-button__iconOnlyGlyph" [innerHTML]="icons['file-download']"></span>
</button>

<mat-menu #exportMenu="matMenu">
  <button mat-menu-item type="button" (click)="export('xlsx')">
    {{ 'EXPORT.XLSX' | translate }}
  </button>
  <button mat-menu-item type="button" (click)="export('csv')">
    {{ 'EXPORT.CSV' | translate }}
  </button>
</mat-menu>
